import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getLanguageSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.SETTINGS_LANGUAGE.GET, null, true);
}

export function* saveLanguageSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.SETTINGS_LANGUAGE.SAVE, action.payload, true);
}
